import { InferResult, QueryCreator, sql } from 'kysely';
import { DatasetDatabase } from '../../datasetQueryBuilder';
import { applyShiftFilter } from '../../datasetQueryBuilder.helper';
import {
  DATASET_QUERY_VALUE_CONCATENATION,
  DocumentContextQueryBuilderParams,
} from '../../datasetQueryBuilder.types';

export type ActualityExtendedEventDataRows = InferResult<
  ReturnType<typeof getActualityExtendedEventQueryBuilder>
>;
export type ActualityExtendedEventDataRow =
  ActualityExtendedEventDataRows[number];
export type ActualityExtendedEventDataColumn =
  keyof ActualityExtendedEventDataRow;

export function getActualityExtendedEventQueryBuilder<
  T extends DatasetDatabase,
>(
  documentContext: DocumentContextQueryBuilderParams,
  db: QueryCreator<T> /* QueryCreator<T>*/,
) {
  let qb = db
    .selectFrom('___actuality_extended_event___')
    .where('datasetObjectId', '=', documentContext.documentId as any)
    .select(eb => [
      'eventId as extendedEventId',
      'eventEndTime as extendedEventEndTime',
      //'skuKey',
      //'activityItem',
      //'jobKey',
      'previousEmployeeJobActivityTime',
      'followingEmployeeJobActivityTime',
      'previousEmployeeActivityTime',
      'followingEmployeeActivityTime',
      'previousJobActivityTime',
      'followingJobActivityTime',
      'previousJobEvent',
      'followingJobEvent',
      'previousJobEventByLocationOrder',
      'followingJobEventByLocationOrder',
      'jobLineSequence',
      'jobLineSequenceByLocationOrder',
      'jobLinesSameProduct',
      'jobLinesSameAssignment',
      'employeeActivityDuration',
      'jobLineDuration',
      sql<string>`${eb.ref('skuKey')} || ${sql.lit(DATASET_QUERY_VALUE_CONCATENATION)} || ${eb.ref('jobKey')} `.as(
        'visitKey',
      ),
    ]);

  qb = applyShiftFilter({ qb, documentContext, field: 'eventEndTime' });

  return qb;
}
